import Pqp from "../../../3x1010/Pqp.js";
import Game from "../../Game.js";

export default class TileWindow {
	constructor(target, rows, cols, sp, showContentWhileDragging = false, lClose = false, idComplexAsset = null, callback = null,modal = false) {
		this.id = TileWindow.ENUM++;
		this.target = target;
		this.rows = rows * 2;
		this.cols = cols * 2;
		this.tilesUpper = new Array();
		this.tilesLower = new Array();
		this.sp = sp;
		this.title = null;
		this.dragSpanx = 0;
		this.dragSpany = 0;
		this.closeButton = lClose;
		this.showContentWhileDragging = showContentWhileDragging;
		this.callback = callback;
		this.idComplexAsset = idComplexAsset;
		this.modal = modal;
	}
	init(title) {
		this.title = title;
		this.build();
		this.setHeader();
		this.setContent();
		this.setCloseButton();
		if (!this.modal) {
			this.setDraggable();
		} else {
			jQuery(".js-window-header", this.mc).css("cursor", "default");
		}
	}

	destroy() {
		this.mc.remove();
	}

	width() {
		return this.mc.width();
	}
	height() {
		return this.mc.height();
	}
	css(o) {
		return this.mc.css(o);
	}
	position() {
		return this.mc.position();
	}
	offset() {
		return this.mc.offset();
	}

	build() {
		let win = jQuery("#template-window").clone();
		win.attr("id", "wiga" + TileWindow.ENUM++)
		win.css("z-index", TileWindow.ZINDEX++)
		this.target.append(win)
		//console.log(this.idComplexAsset);
		let complexAsset = this.sp.getComplexAsset(this.idComplexAsset)
		
		if (Game.DEBUG_USE_WIN_STATIC) {
			complexAsset = {
				lower: "assets/ui/windows/" + this.idComplexAsset+"_lower.png",
				upper: "assets/ui/windows/" + this.idComplexAsset+"_upper.png",
			}
		}
		
		if (complexAsset) {
			this.createWithComplexAsset(win, complexAsset);
			this.setDimensions(win,true);
		} else {
			this.createTiles(win);
			this.setDimensions(win,false);
			this.setTiles();

		}
		
		/*if (!this.complexAsset) {

		}*/

	}

	createWithComplexAsset(win, complexAsset) {
		let img = new Image();
		img.src = complexAsset.lower;
		jQuery(".js-window-tiles-lower", win).append(jQuery(img))
		img = new Image();
		img.src = complexAsset.upper;
		jQuery(".js-window-tiles-upper", win).append(jQuery(img))
	}

	createTiles(win) {
		this.tilesUpper = new Array();
		this.tilesLower = new Array();
		for (let row = 0; row < this.rows; row++) {
			this.tilesUpper.push(new Array());
			this.tilesLower.push(new Array());
			for (let col = 0; col < this.cols; col++) {
				let tile = jQuery("#template-window-tile").clone();
				tile.css(
					{
						"left": col * Game.TILE_WIDTH / 2,
						"top": row * Game.TILE_HEIGHT / 2,
						"width": Game.TILE_WIDTH / 2,
						"height": Game.TILE_HEIGHT / 2
					});
				tile.attr("id", "tiwi" + TileWindow.ENUM++);
				tile.attr("data-ref", row + "|" + col);
				this.tilesLower[this.tilesLower.length - 1].push(tile);
				jQuery(".js-window-tiles-lower", win).append(tile)

				let lCreate = false;
				if ((col === 0) || (col === this.cols - 1)) {
					lCreate = true;
				}
				if (row < 3) {
					lCreate = true;
				}
				if (row === this.rows - 1) {
					lCreate = true;
				}

				if (lCreate) {
					tile = jQuery("#template-window-tile").clone();
					tile.css(
						{
							"left": col * Game.TILE_WIDTH / 2,
							"top": row * Game.TILE_HEIGHT / 2,
							"width": Game.TILE_WIDTH / 2,
							"height": Game.TILE_HEIGHT / 2
						});
					tile.attr("id", "tiwi" + TileWindow.ENUM++);
					tile.attr("data-ref", row + "|" + col);
					this.tilesUpper[this.tilesUpper.length - 1].push(tile);
					jQuery(".js-window-tiles-upper", win).append(tile)
				} else {
					this.tilesUpper[this.tilesUpper.length - 1].push(null);
				}


			}
		}
	}

	setDimensions(win,lImage) {
		win.css({
			"width": Game.TILE_WIDTH / 2 * this.cols,
			"height": Game.TILE_HEIGHT / 2 * this.rows
		});
		this.mc = win;
		if (lImage) {
			jQuery("img", jQuery(".js-window-tiles-upper", win)).css({
				"width": Game.TILE_WIDTH / 2 * this.cols,
				"height": Game.TILE_HEIGHT / 2 * this.rows
			});
			jQuery("img", jQuery(".js-window-tiles-lower", win)).css({
				"width": Game.TILE_WIDTH / 2 * this.cols,
				"height": Game.TILE_HEIGHT / 2 * this.rows
			});

		}

		jQuery(".js-title", this.mc).text(this.title);

	}

	setTiles() {

		this.writeRow(0, 0);
		this.writeRow(1, 1);
		this.writeRow(2, 2);
		this.writeRow(this.rows - 1, 3);
		for (let x = 3; x < this.rows - 1; x++) {
			this.writeRow(x, 4, 1);
		}

		this.tmpBegin = 0;
		for (let x = 2; x < this.rows; x++) {
			this.writeBack(x);
		}


	}


	writeRow(row, srcRow, howMany = -1) {
		let customs = TileWindow.CUSTOM_TILES
		let leftPart = Math.floor(this.cols / 2) - customs;
		if (leftPart < 0) {
			leftPart = Math.floor(this.cols / 2)
		} else {
			leftPart = customs
		}
		//console.log(leftPart)
		if (howMany !== -1) {
			leftPart = howMany
		}

		for (let x = 0; x < leftPart; x++) {
			let sprite = this.getSprite(srcRow, x)
			jQuery(".js-upper", this.tilesUpper[row][x]).css("background-image", "url('" + sprite + "')");
		}

		for (let x = 0; x < leftPart; x++) {
			let sprite = this.getSprite(srcRow, x)
			jQuery(".js-upper", this.tilesUpper[row][(this.cols - 1) - x]).css("background-image", "url('" + sprite + "')");
			jQuery(".js-upper", this.tilesUpper[row][(this.cols - 1) - x]).addClass("window-tile-flip-w")
		}

		if (howMany == -1) {
			let repeat = this.cols - leftPart * 2;
			let which = 6
			if (leftPart < customs) {
				which = leftPart;
			}
			for (let x = leftPart; x < leftPart + repeat; x++) {
				let sprite = this.getSprite(srcRow, which)
				jQuery(".js-upper", this.tilesUpper[row][x]).css("background-image", "url('" + sprite + "')");
			}
		}

	}

	writeBack(row) {

		let customs = TileWindow.CUSTOM_TILES
		let leftPart = Math.floor(this.cols / 2) - customs;
		if (leftPart < 0) {
			leftPart = Math.floor(this.cols / 2)
		} else {
			leftPart = customs
		}


		for (let x = 0; x < leftPart; x++) {
			let sprite = this.getSprite(this.tmpBegin + 5, x)
			jQuery(".js-lower", this.tilesLower[row][x]).css("background-image", "url('" + sprite + "')");
		}

		for (let x = 0; x < leftPart; x++) {
			let sprite = this.getSprite(this.tmpBegin + 5, x)
			jQuery(".js-lower", this.tilesLower[row][(this.cols - 1) - x]).css("background-image", "url('" + sprite + "')");
			jQuery(".js-lower", this.tilesLower[row][(this.cols - 1) - x]).addClass("window-tile-flip-w")
		}

		let which = 6
		if (leftPart < customs) {
			which = leftPart - 1;
		}

		let repeat = this.cols - leftPart * 2;
		for (let x = leftPart; x < leftPart + repeat; x++) {
			let sprite = this.getSprite(this.tmpBegin + 5, which)
			jQuery(".js-lower", this.tilesLower[row][x]).css("background-image", "url('" + sprite + "')");
		}

		this.tmpBegin++;
		if (this.tmpBegin > 5) {
			this.tmpBegin = 0;
		}

	}


	setHeader() {
		jQuery(".js-window-header", this.mc).css({
			"width": Game.TILE_WIDTH / 2 * this.cols,
			"height": Game.TILE_HEIGHT / 2 * 3
		});

	}
	setContent() {
		jQuery(".js-window-content", this.mc).css({
			"width": (Game.TILE_WIDTH / 2) * (this.cols),
			"height": (Game.TILE_HEIGHT / 2) * (this.rows - 2),
			//"left": (Game.TILE_WIDTH),
			"top": Game.TILE_HEIGHT / 2 * 2
		});

	}


	getSprite(row, col) {
		return this.sp.getSprite("wintileset", row, col);
	}

	getContentArea() {
		return jQuery(".js-window-content", this.mc)
	}


	setDraggable() {
		this.whereDrag = jQuery(".js-window-header", this.mc)
		this.drag = this.mc
		if (Pqp.isMobile()) {
			this.whereDrag.on("touchstart", this.startPress.bind(this));
		} else {
			this.whereDrag.on("mousedown", this.startPress.bind(this));
		}
	}

	setOverAll() {
		this.mc.css("z-index", TileWindow.ZINDEX++)
	}

	startPress(e) {
		this.bringToTop();
		//jQuery("html").addClass("noselect");
		//jQuery("body").addClass("noselect");
		this.prevent(e)
		if (Pqp.isMobile()) {
			jQuery(window).on("touchend", this.stopPress.bind(this));
			jQuery(window).on("touchmove", this.moveTouch.bind(this));
		} else {
			jQuery(window).on("mouseup", this.stopPress.bind(this));
			jQuery(window).on("mousemove", this.moveTouch.bind(this));
		}
		var mouse = this.getMousePosition(e);
		var tmp = jQuery.globalToLocal(this.whereDrag, mouse.x, mouse.y);
		this.offestx = tmp.x;
		this.offesty = tmp.y;

		this.toReadd = new Array();
		if (!this.showContentWhileDragging) {
			this.toReadd.push(jQuery(".js-window-tiles-lower", this.mc));
			//this.toReadd.push(jQuery(".js-window-content", this.mc));
			for (let x = 0; x < this.toReadd.length; x++) {
				this.toReadd[x].remove();
			}
		}

	}

	bringToTop() {
		this.mc.css("z-index", TileWindow.ZINDEX++);
	}

	prevent(e) {
		if (this.mobile) {
			e.preventDefault();
		}
	}

	getMousePosition(e) {
		var o = new Object();
		if (this.mobile) {
			o.x = e.originalEvent.touches[0].pageX;
			o.y = e.originalEvent.touches[0].pageY;
		} else {
			e = e || window.event; // IE-ism
			o.x = e.clientX;
			o.y = e.clientY;
		}
		return o;
	}

	moveTouch(e) {
		var mouse = this.getMousePosition(e);
		this.lastMousePosition = mouse// jQuery.globalToLocal(this.mc, mouse.x, mouse.y);
		//console.log(this.lastMousePosition);
		this.putDrag(this.lastMousePosition)
	}

	putDrag(e) {
		var newPosx = e.x;
		var newPosy = e.y;

		if (newPosx - this.offestx + this.mc.width() > jQuery(window).outerWidth()) {
			newPosx = jQuery(window).outerWidth() + this.offestx - this.mc.width()
		}
		if (newPosy - this.offesty + this.mc.height() > jQuery(window).outerHeight()) {
			newPosy = jQuery(window).outerHeight() + this.offesty - this.mc.height()
		}

		if (newPosx - this.offestx < 0) {
			newPosx = this.offestx;
		}
		if (newPosy - this.offesty < 0) {
			newPosy = this.offesty;
		}

		//var dif = this.drag.width() - this.offestx;
		//var difh = this.drag.height() - this.offesty;
		/*if (newPos < 0 - dif + this.dragSpanx) {
			newPos = 0 - dif + this.dragSpanx;
		}
		if (newPos > this.slidew - dif + this.dragSpanx) {
			newPos = this.slidew - dif + this.dragSpanx;
		}*/
		//console.log(this.offestx)
		this.drag.css({ left: newPosx - this.offestx, top: newPosy - this.offesty });

	}

	stopPress() {
		//jQuery("html").removeClass("noselect");
		//jQuery("body").removeClass("noselect");

		jQuery(window).off("touchend");
		jQuery(window).off("touchmove");
		jQuery(window).off("mouseup");
		jQuery(window).off("mousemove");

		for (let x = 0; x < this.toReadd.length; x++) {
			this.mc.append(this.toReadd[x]);
		}

	}

	addContent(clipContent, clipContentClass) {
		this.clipContent = clipContent;
		this.clipContentClass = clipContentClass;
		this.getContentArea().append(clipContent);
		clipContentClass.tileWindow = this;
	}

	setCloseButton() {
		let but = jQuery(".js-close", this.mc);
		if (this.closeButton) {
			jQuery(".js-pict ", but).css("background-image", "url('" + "./assets/ui/btn_close.png" + "')");
			but.on("click", this.closeWindow.bind(this));
		} else {
			but.hide();
		}

	}

	closeWindow() {
		this.dispatch({ type: TileWindow.EVENT_CLOSE, target:this })
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}



}
TileWindow.ENUM = 0;
TileWindow.CUSTOM_TILES = 6;
TileWindow.ZINDEX = 100;
TileWindow.EVENT_CLOSE = "eventClose";